var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-1603 -7423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 50,
    height: 40,
    transform: "translate(1603 7423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "download-2",
    "data-name": "download",
    d: "M1443.5-2239a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h23a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5Zm11.1-5.034-8-10.667a.5.5,0,0,1,.4-.8h3.5V-2268a1,1,0,0,1,1-1h7a1,1,0,0,1,1,1v12.5h3.5a.5.5,0,0,1,.4.8l-8,10.667a.5.5,0,0,1-.4.2A.5.5,0,0,1,1454.6-2244.033Z",
    transform: "translate(173 9697)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.a1d043b17776ad45fac3bf6cdb218044.svg";
export { ForwardRef as ReactComponent };